export const environment = {
  production: true,
  apiUrl: 'https://dev.controlcuentas.srv1954566.hstgr.cloud/api',
};
